import 'babel-polyfill'

import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'

import VueImg from 'v-img'
Vue.use(VueImg);

import moment from 'moment'

window.moment = moment;
import 'moment/locale/cs';
window.moment.locale("cs");

import TmplHelper from './assets/th.js';
window.TH = TmplHelper;
window.th = TmplHelper;

import API from './assets/api.js'
window.API = API;
window.api = API;

import Kosik from './assets/kosik.js'
window.Kosik = Kosik;
window.kosik = Kosik;

window.testovaci_klient = false;

var MobileDetect = require('mobile-detect');
window.MobileDetect = new MobileDetect(window.navigator.userAgent);

import Link from '@/components/Link'
Vue.component("eshop-link", Link);

import ExternalLink from '@/components/ExternalLink.vue'
Vue.component("external-link", ExternalLink);

import ButtonLink from '@/components/ButtonLink'
Vue.component("button-link", ButtonLink);

import DatePicker from '@/components/DatePicker'
Vue.component("datepicker", DatePicker);

import Kraje from '@/components/Kraje'
Vue.component("kraje", Kraje);

import Pobocky from '@/components/Pobocky'
Vue.component("pobocky", Pobocky);

import Meny from '@/components/Meny'
Vue.component("meny", Meny);

import ZpusobyDoruceni from '@/components/ZpusobyDoruceni'
Vue.component("zpusoby-doruceni", ZpusobyDoruceni);
Vue.component("zpusobydoruceni", ZpusobyDoruceni);

import Adresa from '@/components/Adresa'
Vue.component("adresa", Adresa);

import VyberAdresy from '@/components/VyberAdresy'
Vue.component("vyber-adresy", VyberAdresy);

import MenyRadio from '@/components/MenyRadio'
Vue.component("menyradio", MenyRadio);
Vue.component("meny-radio", MenyRadio);

import ProductSearch from '@/components/ProductSearch'
Vue.component("productsearch", ProductSearch);

import SporiciProduktSearch from '@/components/SporiciProduktSearch'
Vue.component("sporiciproduktsearch", SporiciProduktSearch);
Vue.component("sporici-produkt-search", SporiciProduktSearch);

import SporiciCilovyProduktSearch from '@/components/SporiciCilovyProduktSearch'
Vue.component("sporicicilovyproduktsearch", SporiciCilovyProduktSearch);
Vue.component("sporici-cilovy-produkt-search", SporiciCilovyProduktSearch);

import AdresaView from '@/components/AdresaView'
Vue.component("adresaview", AdresaView);
Vue.component("adresa-view", AdresaView);

import SubNavigation from '@/components/SubNavigation'
Vue.component("sub-navigation", SubNavigation);

import SubNavigationObchody from '@/components/SubNavigationObchody'
Vue.component("sub-navigation-obchody", SubNavigationObchody);

import SpolupracovniciPodrizeni from '@/components/SpolupracovniciPodrizeni'
Vue.component("spolupracovnici-podrizeni", SpolupracovniciPodrizeni);

import ZaplacenoProcent from '@/components/ZaplacenoProcent'
Vue.component("zaplaceno-procent", ZaplacenoProcent);

import Obdobi from '@/components/Obdobi'
Vue.component("obdobi", Obdobi);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('DD.MM.YYYY HH:mm')
  }
});

Vue.filter('formatSimpleDate', function(value) {
  if (value) {
    return moment(new Date(value*1000)).format('DD.MM.YYYY')
  }
});

Vue.filter('formatMoney', function(value) {
  if (value) {
    return window.th.formatPrice(value, 2, ",", " ")
  }
  return "0,00";
});

Vue.filter('formatMoneyInt', function(value) {
  if (value) {
    return window.th.formatPrice(value, 0, ",", " ")
  }
  return "0";
});

Vue.filter('formatDouble', function(value) {
  if (value) {
    return window.th.formatDouble(value)
  }
  return "0,00";
});

Vue.filter('formatInt', function(value) {
  if (value) {
    return window.th.formatPrice(value, 0, ",", " ")
  }
  return "0";
});

Vue.filter('formatPrice', function(value) {
  if (value) {
    return window.th.formatPrice(value, 2, ",", " ")
  }
  return "0,00";
});

Vue.filter('formatFileSize', function(value) {
  if (value) {
    return window.th.humanFileSize(value, true)
  }
  return "";
});

Vue.filter('lowerCase', function(value) {
  if (value) {
    return value.toString().toLowerCase()
  }
  return "";
});

Vue.filter('upperCase', function(value) {
  if (value) {
    return value.toString().toUpperCase()
  }
  return "";
});

import Loader from './components/Loader'
Vue.component('Loader', Loader);

import Base from './Base.vue'
Vue.use(Base)

Array.prototype.clear = function() {
  while (this.length) {
    this.pop();
  }
};

Array.prototype.merge = function(arr) {
  if (arr != null)
    for (var $i = 0; $i < arr.length; $i++)
      this.push(arr[$i]);
};

Array.prototype.replace = function(arr) {
  this.clear();
  this.merge(arr);
};

if (!Array.prototype.filterOne)
  Array.prototype.filterOne = function(e) {
    var f = this.filter(e);
    return f.length > 0 ? f[0] : null;
  }

/*Vue.component('indicator', {
  template:'<div id="indicator"></div>',
  mounted:function(){
    var vm = this
    window.addEventListener('scroll', function(e){
      var scrollPos = window.scrollY
      console.log(scrollPos)
      var winHeight = window.innerHeight
      var docHeight = document.documentElement.scrollHeight
      var perc = 100 * scrollPos / (docHeight - winHeight)
      vm.$el.style.width = perc + '%'
    })
  }
})*/

router.afterEach((to, from, next) => {
  window.testovaci_klient = to.path.startsWith("/testovaci-klient");
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
